import React, { useState, useEffect, useReducer } from 'react'
import { Icon, Button, Row, Col, List, Input, InputGroup, FlexboxGrid, Modal, IconButton } from 'rsuite'
import notification from '../../utils/notification'
import { getReceivedFrom, getReceivedFromById } from '../../redux/actions/incomeAndExpense'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { startLoading, doneLoading } from '../../utils/loading'
import './styles.less'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { isEmpty } from 'lodash-es'
import { maskIdCard } from '../../utils/dataUtil'
import { useForm, Controller } from 'react-hook-form'
import CreatePayeeAndTaxInfoForm from '../createPayeeAndTaxInfo/CreatePayeeAndTaxInfoForm'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { saveCreatePayeeAndTax } from '../../redux/actions/createPayeeAndTax'
export default function PayeeModalWidget({
  title,
  projectCode,
  show,
  isViewMode,
  onSelect = () => { },
  onClose = () => { },
  expenseForId,
  isSubproject = null,
  formSchema,
  ...props
}) {
  const [isLoading, setIsLoading] = useState()
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } = useForm()
  const [expenseForSchema, setExpenseForSchema] = useState()
  const [searchNameOrId, setSearchNameOrId] = useState()
  const [formSchemaForAdd, setFormSchemaForAdd] = useState(null)
  const [_, forceUpdate] = useReducer((x) => x + 1, 0)
  // const [isExpandedForm, setIsExpandedForm] = useState(true)
  const [isAddBankAccount, setIsAddBankAccount] = useState(false)
  const [selectRowData, setSelectRowData] = useState()
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  // const _styleCellSummary = { backgroundColor: '#1f5581', color: '#fff', fontWeight: 'bold' }
  // const fs = localStorage.getItem('fontSize')

  const styleCenter = {
    textAlign: 'center',
  }

  useEffect(() => {
    handleCallReceivedFrom(null, expenseForId)
  }, [])
  const handleAddBankAccount = async () => {
    if (expenseForSchema && expenseForSchema.addDataForm) {
      setFormSchemaForAdd(expenseForSchema.addDataForm) 
      setIsAddBankAccount(true) 
    } else { 
      notification.open('error', { title: 'ไม่พบข้อมูลโครงสร้างฟอร์ม (addDataForm)', duration: 3000 })
    }
    
  }
  const handleCallReceivedFrom = async (nameOrId, id) => {
    setIsLoading(true)
    startLoading()

    try {
      let response
      if (id) {
        response = await getReceivedFromById(id)
        console.log('response : ', response)
      } else {
        response = await getReceivedFrom(
          projectCode,
          nameOrId,
          isSubproject != null ? (isSubproject ? '1' : '0') : ''
        )
      }

      if (response) {
        if (id) {
          let _schema = { values: [response] }
          setExpenseForSchema(_schema)
        } else {
          setExpenseForSchema(response)
        }
        // setExpenseForSchema(response)
        setTimeout(() => {
          forceUpdate()
        }, 500)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }
  const onSubmit = (data) => {
    // console.log('data', data)
    // console.log('selectRowData', selectRowData)
    let request = {
      id: selectRowData?.id ? selectRowData.id : null,
      projectCode: projectCode,
      regiterType: data.regiterType,
      idCard: data.idCard,
      expenseForNameOrOrg: data.expenseForNameOrOrg,
      title: data.titleName,
      lastName: data.lastName,
      address: data.address,
      expenseForTax: data.expenseForTax || false,
      vatRegistration: data.vatRegistration || false,
      roles: data.roles,
      buildingName: data.buildingName,
      roomNumber: data.roomNumber,
      numberOfAddress: data.houseNumber,
      moo: data.villageNumber,
      box: data.lane,
      villageName: data.villageName,
      roadName: data.road,
      location: data.location,
      branchCode: data.branchCode,
      email: data.email,
      phoneNumber: data.phoneNumber,
      subProjectCode: data.subProjectCode,
    }
    // setIsShowConfirm(true)
    handleCallService(request)
    // console.log('onSubmit', request)
  }
  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    // setIsError(false)

    try {
      let response = await saveCreatePayeeAndTax(projectCode, request)
      if (response) {
        // clearValues()
        // setIsExpanded(true)
        setIsAddBankAccount(false)
        setSelectRowData()
        // setFormSchema(response.forms)
        // console.log('response', response)
        handleCallReceivedFrom(null)
      } else {
        // setIsError('ไม่สำเร็จ')
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      // setIsError(e.response.data.errors?.message || DEFAULT_ERR_MSG)
      notification.open('error', {
        title: e.response.data.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }
  return (
    <Modal full show={show} onHide={onClose}>
      <Modal.Header>
        <Modal.Title>{title || 'รายการ'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ width: '99%' }}>
          {!isViewMode && (
            <Row>
              <Col lg={12} md={12} sm={24} xs={24} style={{ width: '60%' }}>
                <InputGroup style={{ width: '100%' }}>
                  <Input
                    defaultValue={searchNameOrId}
                    value={searchNameOrId}
                    placeholder={'ระบุชื่อ หรือ เลขที่ผู้เสียภาษี'}
                    onChange={(value) => {
                      setSearchNameOrId(value)
                      // handleCallReceivedFrom(value)
                    }}
                  />

                  <InputGroup.Button
                    style={{ color: '#fff', backgroundColor: '#2ba888' }}
                  //onClick={() => handleCallReceivedFrom(searchNameOrId)}
                  >
                    <Icon icon="search" size="lg" /> ค้นหา
                  </InputGroup.Button>
                </InputGroup>
              </Col>
              <Col lg={12} md={12} sm={24} xs={24} style={{ width: '40%' }}>
                <CancelButton
                  onClick={() => {
                    //handleCallReceivedFrom(null)
                    setSearchNameOrId('')
                  }}
                >
                  ยกเลิก
                </CancelButton>
              </Col>
              <Col lg={12} md={12} sm={24} xs={24} style={{ width: '100%' }}>
                <IconButton
                  appearance="primary"
                  icon={<Icon icon="plus" />}
                  onClick={() => {
                    handleAddBankAccount()
                  }}
                  //size="sm"
                  style={{ float: 'right', margin: 10 }}
                >
                  เพิ่ม
                </IconButton>
              </Col>
              {formSchemaForAdd &&( 
                <Modal
                  size="lg"
                  show={isAddBankAccount}
                  onHide={() => {
                    // setIsExpandedForm(true)
                    setIsAddBankAccount(false)
                  }}
                >
                  <Modal.Header>
                    <Modal.Title>เพิ่มข้อมูล</Modal.Title>
                  </Modal.Header>

                  <Modal.Body style={{ paddingBottom: 20 }}>
                    <CreatePayeeAndTaxInfoForm
                      schema={formSchemaForAdd}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      getValues={getValues}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      isAddBankAccount={true}
                    />
                  </Modal.Body>

                  <Modal.Footer>
                    <SaveButton onClick={handleSubmit(onSubmit)}>บันทึก</SaveButton>
                    <CancelButton
                      onClick={() => {
                        // setIsExpandedForm(true)
                        setIsAddBankAccount(false)
                      }}
                    >
                      ยกเลิก
                    </CancelButton>
                  </Modal.Footer>
                </Modal>
              )}

              {/* 🟡 Confirm Widget เอาไว้ข้างนอกสุดเช่นกัน */}
              <ConfirmWidget
                title={'ยืนยันการเพิ่ม'}
                show={isShowConfirm}
                detail={'ยืนยันการเพิ่มข้อมูล'}
                onCancle={() => setIsShowConfirm(false)}
                onConfirm={handleCallService}
              />
            </Row>
          )}

          <div style={{ minHeight: 200, maxHeight: '70hv' }}>
            <List hover>
              <List.Item key={'header_'} index={-1} style={{ backgroundColor: '#F2F1F1' }}>
                <FlexboxGrid style={{ fontWeight: 550 }}>
                  <FlexboxGrid.Item colspan={1} style={{ ...styleCenter }}>
                    ลำดับ
                  </FlexboxGrid.Item>

                  <FlexboxGrid.Item colspan={4}>
                    <div>เลขที่ผู้เสียภาษี</div>
                  </FlexboxGrid.Item>
                  {/* <FlexboxGrid.Item colspan={3}>
                    <div>เลขรหัสกำกับ</div>
                  </FlexboxGrid.Item> */}
                  <FlexboxGrid.Item colspan={6}>
                    <div>ชื่อ/รายการ</div>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item colspan={!isViewMode ? 6 : 7}>
                    <div>ที่อยู่/คำอธิบายรายการ</div>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item colspan={3} style={{ ...styleCenter }}>
                    <div>ให้หัก ณ.ที่จ่ายนำส่ง</div>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item colspan={3} style={{ ...styleCenter }}>
                    <div>จดภาษีมูลค่าเพิ่ม</div>
                  </FlexboxGrid.Item>
                  {!isViewMode && (
                    <FlexboxGrid.Item colspan={1} style={styleCenter}>
                      เลือก
                    </FlexboxGrid.Item>
                  )}
                </FlexboxGrid>
              </List.Item>
              {isLoading ? (
                <OverlayLoader />
              ) : (
                <>
                  {expenseForSchema?.values
                    ?.filter(
                      (e) =>
                        isEmpty(searchNameOrId) ||
                        e?.name?.toLowerCase()?.includes(searchNameOrId) ||
                        (e?.registerType != '9' &&
                          e?.taxId?.toLowerCase()?.includes(searchNameOrId))
                    )
                    ?.map((item, index) => (
                      <List.Item
                        key={item['title']}
                        index={index}
                        style={{ wordWrap: 'break-word' }}
                      >
                        <FlexboxGrid>
                          <FlexboxGrid.Item colspan={1} style={styleCenter}>
                            {index + 1}
                          </FlexboxGrid.Item>

                          <FlexboxGrid.Item colspan={4}>
                            <div>{item['registerType'] != '9' && maskIdCard(item['taxId'])}</div>
                          </FlexboxGrid.Item>

                          {/* <FlexboxGrid.Item colspan={3}>
                          <div>{item['registerType'] == '9' && item['taxId']}</div>
                        </FlexboxGrid.Item> */}

                          <FlexboxGrid.Item colspan={6}>
                            <div>{item['name']}</div>
                          </FlexboxGrid.Item>

                          <FlexboxGrid.Item colspan={!isViewMode ? 6 : 7}>
                            <div>{item['address']}</div>
                          </FlexboxGrid.Item>

                          <FlexboxGrid.Item colspan={3}>
                            <div style={{ ...styleCenter }}>
                              {item['withholding'] ? (
                                <Icon icon="check-circle" size="lg" style={{ color: '#2da888' }} />
                              ) : (
                                <Icon
                                  icon="minus-circle"
                                  size="2x"
                                  style={{ color: '#8080808a' }}
                                />
                              )}
                            </div>
                          </FlexboxGrid.Item>

                          <FlexboxGrid.Item colspan={3}>
                            <div style={{ ...styleCenter }}>
                              {item['vatRegister'] ? (
                                <Icon icon="check-circle" size="lg" style={{ color: '#2da888' }} />
                              ) : (
                                <Icon
                                  icon="minus-circle"
                                  size="2x"
                                  style={{ color: '#8080808a' }}
                                />
                              )}
                            </div>
                          </FlexboxGrid.Item>
                          {!isViewMode && (
                            <FlexboxGrid.Item colspan={1} style={styleCenter}>
                              <Button
                                appearance="primary"
                                size="xs"
                                onClick={() => {
                                  onSelect(item)
                                }}
                              >
                                เลือก
                              </Button>
                            </FlexboxGrid.Item>
                          )}
                        </FlexboxGrid>
                      </List.Item>
                    ))}
                </>
              )}
            </List>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          style={{ marginTop: 10, marginBottom: -5 }}
          appearance="subtle"
          onClick={onClose}
        // className="rs-btn-ghost-cancel"
        >
          ปิด
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
